// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';

export function MpcreditoMessage(): Node {
  return (
    <Root>
      <Title>Novidade</Title>
      <Message>Compre agora e pague depois em até 12x sem precisar de cartão</Message>
    </Root>
  );
}

const Root = styled.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 20px;
  margin: 20px;
  color: #000e2b;
  font-style: normal;
  font-size: 14px;
  line-height: 150%;
  letter-spacing: -0.01em;
  background: #e4fbfa;
  border-radius: 8px;
`;

const Title = styled.div`
  background: #01a39b;
  padding: 4px 6px;
  border-radius: 4px;
  color: #ffffff;
  font-weight: 800;
  display: inline;
`;

const Message = styled.div`
  display: block;
  padding-top: 10px;
`;
